<template>
    <div
        v-if="empty"
        class="object-related-access-notice object-related-access-notice--empty"
        role="status"
    >
        <i class="fas fa-lock" aria-hidden="true"></i>
        <span>По объекту есть {{ entityLabel }}, но у вас нет доступа к их просмотру</span>
    </div>
    <b-alert
        v-else
        show
        variant="info"
        class="object-related-access-notice object-related-access-notice--partial"
    >
        <i class="fas fa-lock mr-1" aria-hidden="true"></i>
        Показаны только доступные вам {{ entityLabel }}. Часть данных скрыта настройками доступа.
    </b-alert>
</template>

<script>
export default {
    name: `ObjectRelatedAccessNotice`,
    props: {
        empty: {
            type: Boolean,
            default: false
        },
        entityLabel: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped>
.object-related-access-notice--empty {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 14px;
    border: 1px solid #b8daff;
    border-radius: 5px;
    background: #f0f7ff;
    color: #084298;
    font-weight: 700;
}

.object-related-access-notice--partial {
    margin-bottom: 10px;
}
</style>
